//export action types
export const SET_SELECTED_EMAIL_EMBED = 'SET_SELECTED_EMAIL_EMBED';
export const LOADING_EMAILS = 'LOADING_EMAILS';
export const DOWNLOADING_EMAILS = 'DOWNLOADING_EMAILS';
export const CLEAR_SELECTED_EMAIL_STATE = 'CLEAR_SELECTED_EMAIL_STATE';



//actions

export const setSelectedEmailEmbed = (embedUUID, embedName) => ({
    type: SET_SELECTED_EMAIL_EMBED,
    embedUUID,
    embedName
});

export const loadingEmails = status => ({
    type: LOADING_EMAILS,
    status
});

export const downloadingEmails = status  => ({
    type: DOWNLOADING_EMAILS,
    status
});

export const clearSelectedEmailState = () => ({
    type: CLEAR_SELECTED_EMAIL_STATE
});